<template>
  <div
    class="question-display-item mb-3 border-bottom pb-2"
    :class="answerClass"
  >
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="font-weight-bold mb-0">
        {{ displayNumber }}{{ question.name }}
        <span v-if="!isListType">
          <b-badge
            v-if="question.answer.isCorrect"
            variant="success"
            class="answer-badge ms-2"
          >
            <b-icon
              icon="check-circle-fill"
              class="me-1 readable-badge-content"
            ></b-icon
            ><span class="readable-badge-content">Sí</span>
          </b-badge>
          <b-badge v-else variant="danger" class="answer-badge ms-2">
            <b-icon
              icon="x-circle-fill"
              class="me-1 readable-badge-content"
            ></b-icon
            ><span class="readable-badge-content">No</span>
          </b-badge>
        </span>
      </h6>
    </div>

    <b-collapse
      :id="`details-collapse-qdisplay-${question.id}-${itemIndex}`"
      :visible="showSocietyDetails"
    >
      <div
        v-if="
          question.answer &&
          question.answer.questionSocieties &&
          question.answer.questionSocieties.length > 0
        "
        class="mt-2 mb-2 ps-3"
      >
        <SocietyTable
          :questionName="''"
          :societies="question.answer.questionSocieties"
          :fieldNameCargo="question.fieldNameCargo || 'Rol'"
          :fieldNameDate="question.fieldNameDate || 'Periodo'"
        ></SocietyTable>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import SocietyTable from "@/components/shared/Statements/Society-table.vue";

export default {
  name: "FamilyQuestionDisplay",
  components: {
    SocietyTable,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isListType() {
      return this.question.type === "SocietyList";
    },
    answerClass() {
      if (this.isListType) {
        return "answer-neutral";
      }
      if (this.question && this.question.answer) {
        if (this.question.answer.isCorrect === true) {
          return "answer-correct";
        }
        if (this.question.answer.isCorrect === false) {
          return "answer-incorrect";
        }
      }
      return "answer-neutral"; // Default if no answer or isCorrect is null/undefined
    },
    displayNumber() {
      return `${this.itemIndex + 1}. `;
    },
    showSocietyDetails() {
      if (this.isListType) {
        return true;
      }
      return !!(
        this.question &&
        this.question.answer &&
        this.question.answer.isCorrect === true
      );
    },
  },
};
</script>

<style scoped>
.question-display-item {
  background-color: #f8f9fa;
}

.answer-badge {
  padding: 0.3em 0.6em;
  font-size: 0.9em;
  vertical-align: middle;
}

.readable-badge-content {
  color: #212529;
}
</style>
